<template>
  <div class="start-cluster">
    <input
      id="start-cluster__input"
      class="start-cluster__input"
      type="text"
      placeholder="实例数量"
      v-model="inputValue"
      :change="checkNumber()"
    />
    <div
      class="start-cluster__btn"
      :class="{disabled: inputDisabled}"
      @click="startNewCluster"
    >启动新集群</div>
  </div>
</template>

<script>
export default {
  name: "StartCluster",
  data() {
    return {
      inputValue: 1,
      inputDisabled: false
    };
  },
  methods: {
    checkNumber: function() {
      let val = this.inputValue.toString();
      val = val.replace(/[^\d]/g, ""); // 清除 数字 和 点 以外的字符
      if (val.indexOf(".") < 0 && val != "") {
        val = parseInt(val);
        this.inputValue = val;
      }
      this.inputDisabled = Number(this.inputValue) === 0;
    },
    startNewCluster() {
      if (!this.inputDisabled && this.inputValue !== "") {
        this.$layer.confirm(
          `确定要启动${this.inputValue}个实例的新集群吗？`,
          layerId => {
            this.$layer.close(layerId);
            this.$router.push({
              query: {
                apply_data: "newCluster",
                num: this.inputValue,
                t: +new Date()
              }
            });
          }
        );
      }
    }
  }
};
</script>

<style lang="less" scoped>
.start-cluster {
  font-size: 0.86rem;
  display: flex;
  flex-direction: row;
  justify-content: center;
  justify-items: center;

  &__input-label {
    line-height: 2.4rem;
  }
  &__input {
    outline: none;
    width: 12rem;
    line-height: 2rem;
    border-radius: 0.56rem;
    padding-left: 0.2rem;
    //   background-color: #262934;
  }

  &__btn {
    cursor: pointer;
    margin-left: 2rem;
    padding: 0 1.5rem;
    line-height: 2.4rem;
    border-radius: 0.34rem;
    background-color: rgba(255, 120, 19, 1);

    &.disabled {
      cursor: not-allowed;
      background-color: rgba(255, 120, 19, 0.7);
      color: rgba(255, 255, 255, 0.7);
    }
  }
}
</style>